import React from "react";
import PropTypes from "prop-types";

import {isAfter} from 'date-fns'
import { useFormatMessage } from '../../intl/intlHooks';
import {promoMessages} from "./PromoBlockMessages";

const PromoBlock = ({ promo }) => {
    const lang = navigator.language.toLowerCase();
    const endDate = promo.endDate ? new Date(Date.parse(promo.endDate)).toLocaleString(lang) : null;
    const soldOutDate = promo.soldOutDate ? new Date(Date.parse(promo.soldOutDate)) : null;
    const currentTime = new Date();
    const isPromoSoldOut = isAfter(currentTime, soldOutDate);
    const formatMessage = useFormatMessage();

    return (
        <div className="promo-block">
            <div className="promo-block__title">
                {isPromoSoldOut && (
                    <span>{formatMessage(promoMessages.promoDisplaySoldOut)}</span>
                    )}
                {promo.promoDisplayTitle}
            </div>

            { endDate && (
                <div className="promo-block__end-date">
                    {formatMessage(promoMessages.promoOfferEndDate, {endDate: endDate.toString()})}
                </div>
            )}

            <div className="promo-block__description">
                {promo.promoDisplayShortDesc}
                &nbsp;
                {promo.promoTerms && (
                    <a className="promo-block__terms-link" href={`${window.location.origin}/${promo.promoTerms}`}>
                        {formatMessage(promoMessages.promoTermsAndConditions)}
                    </a>
                )}
            </div>
        </div>
    )
};

PromoBlock.propTypes = {
    promo: PropTypes.shape({
        promoDisplayTitle: PropTypes.string.isRequired,
        promoDisplayShortDesc: PropTypes.string.isRequired,
        endDate: PropTypes.string,
        soldOutDate: PropTypes.string,
        promoTerms: PropTypes.string,
    }).isRequired
};

export default PromoBlock;
